import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_ACCOUNTS_REQUEST = 'GET_ACCOUNTS_REQUEST';
export const GET_ACCOUNTS_SUCCESS = 'GET_ACCOUNTS_SUCCESS';
export const GET_ACCOUNTS_FAILURE = 'GET_ACCOUNTS_FAILURE';

function requestGetAccounts() {
  return {
    type: GET_ACCOUNTS_REQUEST,
    isGettingAccounts: true
  };
}

function receiveGetAccounts(accounts, accountsCount) {
  return {
    type: GET_ACCOUNTS_SUCCESS,
    isGettingAccounts: false,
    accounts,
    accountsCount
  };
}

function rejectGetAccounts() {
  return {
    type: GET_ACCOUNTS_FAILURE,
    isGettingAccounts: false
  };
}

export function getAccounts(pageNumber, pageSize, sortByField, sortDirection, filterList, searchQuery, legalEntity, legalEntitySelected, accountNumber, accountNumberSelected) {
  return (dispatch) => {
    dispatch(requestGetAccounts());
    const promise = () => ApiService
      .getAccounts(pageNumber, pageSize, sortByField, sortDirection, filterList, searchQuery, legalEntity, legalEntitySelected, accountNumber, accountNumberSelected)
      .then((response) => {
        dispatch(receiveGetAccounts(response.data.items, response.data.totalCount));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetAccounts, true));
        }
      });

    return promise();
  };
}

export function getAccountsByObject(requestObject) {
  return getAccounts(
    requestObject.pageNumber,
    requestObject.pageSize,
    requestObject.sortByField,
    requestObject.sortDirection,
    requestObject.filterList,
    requestObject.searchQuery,
    requestObject.legalEntity,
    requestObject.legalEntitySelected,
    requestObject.accountNumber,
    requestObject.accountNumberSelected
  );
}
